/**
 * @copyright © Paramount Streaming
 * @author  Zeeshan Ahmad
 * @description All possible types of Freewheel requests
 */
export enum FreewheelRequestType {
	DAI_API = 'DAI_API',
	DAI_SDK = 'DAI_SDK',
	DAI_SSB = 'DAI_SSB',
	IMA = 'IMA',
}